import axios from 'axios';

import { useGlobalErrorsStore } from '@/shared/hooks/useGlobalErrorsStore';
import { inIframe } from '@/shared/lib/browser';
import { getTiktokSession } from '@/shared/thirdParty/tiktok';
import { GLOBAL_ERROR_TYPE } from '@/shared/types/GlobalError';

import { AUTH_API } from './amplify';
import { BAD_REQUEST_STATUS_CODE, PAYMENT_REQUIRED_STATUS_CODE } from './errors';

export const getToken = async () => {
  if (inIframe()) {
    return getTiktokSession();
  }

  return AUTH_API.getTokenId();
};

export const addRequestInterceptor = () => {
  axios.interceptors.request.use(
    async (config) => {
      if (!config || !config.headers) {
        return config;
      }

      const token = await getToken();
      config.headers.authorization = `Bearer ${token}`;
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const { setGlobalError } = useGlobalErrorsStore.getState();

      if (error.response?.status === PAYMENT_REQUIRED_STATUS_CODE) {
        setGlobalError({ errorType: GLOBAL_ERROR_TYPE.PaymentRequired });
      }
      if (error.response?.status === BAD_REQUEST_STATUS_CODE && error.response?.data?.detail === 'Inactive user') {
        setGlobalError({ errorType: GLOBAL_ERROR_TYPE.InactiveUser });
      }
      return Promise.reject(error);
    },
  );
};
